import React from "react"
import CalorieResultStyle from "./CalorieResultStyle.module.css"
import translate, { keys } from "../../../../../translation/translator"
import LayoutWrapper from "../layoutWrapper/LayoutWrapper"

const CalorieResult = ({
  handleCloseResults,
  units,
  gender,
  weight,
  height,
  age,
  locale,
  dailyActivity,
  sliderValue,
}) => {
  const formulaMetric =
    gender === "Male"
      ? 66 + 13.7 * weight + 5 * height - 6.8 * age
      : 655 + 9.6 * weight + 1.8 * height - 4.7 * age

  const formulaImperial =
    gender === "Male"
      ? 66 + 13.7 * (weight * 0.45359237) + 5 * (height * 30.48) - 6.8 * age
      : 655 + 9.6 * weight + 1.8 * height - 4.7 * age

  let optionResult

  if (dailyActivity === "seated" && sliderValue === 0) {
    optionResult = 1.2
  } else if (dailyActivity === "seated" && sliderValue === 1) {
    optionResult = 1.55
  } else if (dailyActivity === "seated" && sliderValue === 2) {
    optionResult = 1.725
  } else if (dailyActivity === "standing" && sliderValue === 0) {
    optionResult = 1.2
  } else if (dailyActivity === "standing" && sliderValue === 1) {
    optionResult = 1.55
  } else if (dailyActivity === "standing" && sliderValue === 2) {
    optionResult = 1.725
  } else if (dailyActivity === "walking" && sliderValue === 0) {
    optionResult = 1.55
  } else if (dailyActivity === "walking" && sliderValue === 1) {
    optionResult = 1.725
  } else if (dailyActivity === "walking" && sliderValue === 2) {
    optionResult = 1.9
  } else if (dailyActivity === "moving" && sliderValue === 0) {
    optionResult = 1.725
  } else if (dailyActivity === "moving" && sliderValue === 1) {
    optionResult = 1.9
  } else if (dailyActivity === "moving" && sliderValue === 2) {
    optionResult = 1.9
  }
  return (
    <LayoutWrapper locale={locale}>
      <div id="calorie-result" className={CalorieResultStyle.holder}>
        <p className={CalorieResultStyle.text}>
          {translate(keys.DAILY_RECOMMENDED_CALORIES, locale)}
        </p>
        <div className={CalorieResultStyle.result}>
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="utensil-fork"
            className="svg-inline--fa fa-utensil-fork fa-w-16"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M469.5 119.4L356.3 232.6c-3.8 1.7-14.7-9.5-12.9-12.9 19.2-21.5 105.3-117.9 107.3-120.1 14.1-19.3-19.1-52.5-38.4-38.4-2.3 2-98.7 88.1-120.1 107.3-3.4 1.8-14.6-9.1-12.9-12.9L392.5 42.4c15.4-19.4-18.7-53-37.5-39.3-4.4 3.1-88.6 62.8-116.2 90.3-41.8 41.8-49.6 94.1-28.7 139.1L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l180.5-201.2c45 20.9 97.2 13.3 139.1-28.7 27.6-27.6 87.3-111.8 90.4-116.2 13.7-18.7-19.9-52.7-39.3-37.4z"
            />
          </svg>
          {units === "Metric" ? (
            <p className={CalorieResultStyle.formula}>
              {" "}
              {(formulaMetric * optionResult).toFixed(0)} <span>kcal</span>
            </p>
          ) : (
            <p className={CalorieResultStyle.formula}>
              {" "}
              {(formulaImperial * optionResult).toFixed(0)} <span>kcal</span>
            </p>
          )}

          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="utensil-knife"
            className="svg-inline--fa fa-utensil-knife fa-w-16"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M424.9 8.7L20.8 412.8c-11.5 11.5-11.5 30.3 0 41.8l48.8 48.8c12.2 12.2 32.2 11.4 43.4-1.8l148.2-174.3C504.1 357 538.5 80.5 466.7 8.7c-11.6-11.6-30.3-11.6-41.8 0z"
            />
          </svg>
        </div>

        <div className={CalorieResultStyle.recommendation_text}>
          <img
            alt="recommendation"
            src="https://global.dianurse.com/wp-content/uploads/2020/04/examinationsIcon@2x.png"
          />
          <p>{translate(keys.RECOMMENDED_TEXT, locale)}</p>
        </div>
        <button
          onClick={handleCloseResults}
          className={CalorieResultStyle.button}
        >
          {translate(keys.TRY_CALCULATOR_AGAIN_BUTTON, locale)}
        </button>
      </div>
    </LayoutWrapper>
  )
}

export default CalorieResult
